import type {
  FetchPagedS3ObjectsQuery,
  FetchSteelOrdersForPrintQuery,
  S3ObjectResourceTypeEnum,
} from '@mbfab/client-api'

// 印刷（集計表・原本PDF）用の view model。工事名称ごとのグルーピング・ページ番号の主番-枝番採番は
// 選択した発注群を横断する計算のため、1件ずつの変換では表現できない。そのためこのファイルでは
// GraphQL の結果をほぼそのまま画面へ渡す型だけを定義し、グルーピング・採番は print-dialog.tsx（画面側）で行う
// （v1 SteelOrderMillsheetPrintForm と同じ設計）
export type SteelOrderForPrint = FetchSteelOrdersForPrintQuery['steelOrders']['steelOrders'][number]
export type MillsheetForPrint = SteelOrderForPrint['millsheets'][number]

export type S3ObjectForPrint = {
  id: string
  imageWidth: number | null
  imageHeight: number | null
  thumbnailFileUrls: string[]
  fileUrl: string
  resourceType: S3ObjectResourceTypeEnum
}

export function toS3ObjectsForPrint(
  s3Objects: FetchPagedS3ObjectsQuery['pagedS3Objects']['s3Objects'],
): S3ObjectForPrint[] {
  return s3Objects.map((s3Object) => ({
    id: s3Object.id,
    imageWidth: s3Object.imageWidth,
    imageHeight: s3Object.imageHeight,
    thumbnailFileUrls: s3Object.thumbnailFileUrls,
    fileUrl: s3Object.fileUrl,
    resourceType: s3Object.resourceType,
  }))
}

// 印刷ダイアログの読み込み状態。「印刷」ボタン押下（OrdersTable 側）で発火する非同期取得の結果を
// props として PrintDialog へそのまま渡す（画面コンポーネント内で GraphQL を呼ばないための設計。
// 詳細は print-dialog.tsx 冒頭のコメント参照）
export type PrintDialogState =
  | { status: 'closed' }
  | { status: 'loading' }
  | { status: 'error' }
  | { status: 'ready'; orders: SteelOrderForPrint[]; images: S3ObjectForPrint[] }
